var map = {
	"./abc-news-au.png": "cb0d",
	"./abc-news.png": "a8c9",
	"./aftenposten.png": "2353",
	"./al-jazeera-english.png": "416b",
	"./ansa.png": "39cd",
	"./argaam.png": "371a",
	"./ars-technica.png": "5eda",
	"./ary-news.png": "8b91",
	"./associated-press.png": "76ae",
	"./australian-financial-review.png": "4de4",
	"./axios.png": "2ec4",
	"./bbc-news.png": "d1db",
	"./bbc-sport.png": "5dcc",
	"./bild.png": "44f0",
	"./blasting-news-br.png": "f7f3",
	"./bleacher-report.png": "0f32",
	"./bloomberg.png": "ee66",
	"./breitbart-news.png": "4ede",
	"./business-insider-uk.png": "d85a",
	"./business-insider.png": "e8c2",
	"./buzzfeed.png": "3d53",
	"./cbc-news.png": "cfed",
	"./cbs-news.png": "7228",
	"./cbssport.png": "448f",
	"./cnbc.png": "d61e",
	"./cnn-es.png": "8e49",
	"./cnn.png": "47bd",
	"./crypto-coins-news.png": "f961",
	"./daily-mail.png": "1576",
	"./denver.png": "6414",
	"./der-tagesspiegel.png": "3c40",
	"./die-zeit.png": "6bcd",
	"./el-mundo.png": "c489",
	"./engadget.png": "2dda",
	"./entertainment-weekly.png": "5a4e",
	"./espn-cric-info.png": "0b14",
	"./espn.png": "29d5",
	"./financial-post.png": "1570",
	"./financial-times.png": "a76d",
	"./focus.png": "ba3f",
	"./football-italia.png": "e6ce",
	"./fortune.png": "a746",
	"./four-four-two.png": "63fa",
	"./fox-news.png": "a8f1",
	"./fox-sports.png": "5f65",
	"./gizmodo.png": "868c",
	"./globo.png": "657a",
	"./google-news-ar.png": "d491",
	"./google-news-au.png": "1bf3",
	"./google-news-br.png": "d4a2",
	"./google-news-ca.png": "af8f",
	"./google-news-fr.png": "eb2e",
	"./google-news-in.png": "4b33",
	"./google-news-it.png": "9dc2",
	"./google-news-ru.png": "9c01",
	"./google-news-sa.png": "5bf8",
	"./google-news-uk.png": "5dea",
	"./google-news.png": "b70a",
	"./goteborgs-posten.png": "8254",
	"./gruenderszene.png": "f1e5",
	"./hacker-news.png": "55a9",
	"./handelsblatt.png": "311f",
	"./ign.png": "64d0",
	"./il-sole-24-ore.png": "7e81",
	"./independent.png": "963f",
	"./info-money.png": "a820",
	"./infobae.png": "b8d4",
	"./la-gaceta.png": "c3fe",
	"./la-nacion.png": "558f",
	"./la-repubblica.png": "f7d0",
	"./latimes.png": "6af3",
	"./le-monde.png": "81e2",
	"./lenta.png": "b340",
	"./lequipe.png": "2e11",
	"./les-echos.png": "f59e",
	"./liberation.png": "b909",
	"./marca.png": "ed79",
	"./mashable.png": "8013",
	"./medical-news-today.png": "0480",
	"./metro.png": "0dd4",
	"./mirror.png": "d5f0",
	"./msnbc.png": "7664",
	"./mtv-news-uk.png": "2303",
	"./mtv-news.png": "c4ea",
	"./national-geographic.png": "d9a8",
	"./national-review.png": "7085",
	"./nbc-news.png": "95d0",
	"./new-scientist.png": "ad4c",
	"./new-york-magazine.png": "1b39",
	"./news-com-au.png": "cec5",
	"./news24.png": "c5ad",
	"./newsweek.png": "b10e",
	"./next-big-future.png": "8113",
	"./nfl-news.png": "f3fe",
	"./nhl-news.png": "4c10",
	"./npr.png": "0c13",
	"./nrk.png": "5d3a",
	"./nydaily.png": "2795",
	"./nypost.png": "af39",
	"./politico.png": "6f0e",
	"./polygon.png": "4bb9",
	"./rbc.png": "927b",
	"./recode.png": "7308",
	"./reddit-r-all.png": "55a4",
	"./reuters.png": "4fd3",
	"./rt.png": "b81b",
	"./rte.png": "0c76",
	"./rtl-nieuws.png": "eff8",
	"./sabq.png": "610f",
	"./sevenska-dagbladet.png": "fd82",
	"./spiegel-online.png": "44ae",
	"./t3n.png": "dd2e",
	"./talksport.png": "0744",
	"./techcrunch-cn.png": "d7b2",
	"./techcrunch.png": "d104",
	"./techradar.png": "13f5",
	"./the-american-conservative.png": "ca82",
	"./the-economist.png": "5099",
	"./the-globe-and-mail.png": "b16f",
	"./the-guardian-au.png": "e337",
	"./the-guardian-uk.png": "3c5e",
	"./the-hill.png": "8ce8",
	"./the-hindu.png": "2f07",
	"./the-huffington-post.png": "09d8",
	"./the-irish-times.png": "49c9",
	"./the-jerusalem-post.png": "508a",
	"./the-lad-bible.png": "fadc",
	"./the-new-york-times.png": "bef9",
	"./the-next-web.png": "6f7f",
	"./the-sport-bible.png": "4cab",
	"./the-telegraph.png": "0c9b",
	"./the-times-of-india.png": "e1c9",
	"./the-verge.png": "b72a",
	"./the-wall-street-journal.png": "3c27",
	"./the-washington-post.png": "a172",
	"./the-washington-times.png": "7275",
	"./thewrap.png": "3936",
	"./time.png": "fc73",
	"./usa-today.png": "2b75",
	"./vice-news.png": "acb9",
	"./wired-de.png": "21b2",
	"./wired.png": "4f67",
	"./wirtschafts-woche.png": "0068",
	"./xinhua-net.png": "05b5",
	"./ynet.png": "c6ac"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";